import { render, staticRenderFns } from "./StockFavorite.vue?vue&type=template&id=2ab66f3d&scoped=true"
import script from "./StockFavorite.vue?vue&type=script&lang=js"
export * from "./StockFavorite.vue?vue&type=script&lang=js"
import style0 from "./StockFavorite.vue?vue&type=style&index=0&id=2ab66f3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab66f3d",
  null
  
)

export default component.exports